// extracted by mini-css-extract-plugin
export default {"links":"styles_links__n9Pj0","link":"styles_link__FAWZn"};